import { render } from "./DateNav.vue?vue&type=template&id=1924e84f&scoped=true"
import script from "./DateNav.vue?vue&type=script&lang=js"
export * from "./DateNav.vue?vue&type=script&lang=js"

import "./DateNav.vue?vue&type=style&index=0&id=1924e84f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1924e84f"]])

export default __exports__